import { Injectable } from '@angular/core';
import { DateTimeFormatOptions } from "luxon";

@Injectable({ providedIn: 'root' })
export class DwUtils {

	public static chkValidDate(inpDt: string, blankOk = false): boolean {
		if (inpDt === undefined || inpDt.trim().length === 0) {
			return blankOk;
		}

		const trimmed = inpDt.trim();
		const match = trimmed.match(/^(\d{4}-\d{2}-\d{2})/);
		if (!match) {
			return false;
		}
		const datePart = match[1];

		const [yearStr, monthStr, dayStr] = datePart.split('-');
		const year = Number(yearStr);
		const month = Number(monthStr);
		const day = Number(dayStr);

		if (!Number.isInteger(year) || !Number.isInteger(month) || !Number.isInteger(day)) {
			return false;
		}

		if (month < 1 || month > 12 || day < 1 || day > 31) {
			return false;
		}

		const utcDate = new Date(Date.UTC(year, month - 1, day));
		return (
			utcDate.getUTCFullYear() === year &&
			utcDate.getUTCMonth() === month - 1 &&
			utcDate.getUTCDate() === day
		);
	}
	public static formatUTCToTZDate(utcString: string, justDate: boolean = false): string {

		let retStr = '';
		if ((utcString === null) || (utcString === undefined) || (utcString.length === 0)) {
			return retStr;
		}

		try {
			const utcDate: Date = new Date(utcString);

			//retStr = utcDate.getFullYear() + '-' + utcDate.getMonth()+1 + '-' + utcDate.getDay();

			retStr = utcDate.getFullYear() + '-' +
				('0' + (utcDate.getMonth() + 1)).slice(-2) + '-' +
				('0' + utcDate.getDate()).slice(-2);

			if (!justDate) {
				retStr += ' ' + utcDate.getHours() + ":" + utcDate.getMinutes();
			}

		}
		catch { }
		return retStr;
	}
	public static chkDateRange(start: string, end: string): boolean {

		if ((start === undefined) || (end === undefined)) {
			return true;
		}
		const stDate: Date = new Date(start);
		const edDate: Date = new Date(end);

		if (start > end) {
			return false;
		}
		return true;
	}
	public static formatReadableDate(inpDt: Date): string {

		if (inpDt === null) {
			return null;
		}
		const options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }
		return inpDt.toLocaleDateString('en-us', options as DateTimeFormatOptions);
	}
	public static formatReadableStringNoDay(inp: string): string {

		if (inp === null) {
			return;
		}

		const datechop = inp.split('T')[0];
		const datedash = datechop.replace(/-/g, '\/');
		const retVal = this.formatReadableDateNoDay(new Date(datedash));

		return retVal;

	}
	public static formatReadableDateNoDay(inpDt: Date): string {

		if (inpDt === null) {
			return null;
		}
		const options = { year: 'numeric', month: 'short', day: 'numeric' }
		return inpDt.toLocaleDateString('en-us', options as DateTimeFormatOptions);
	}
	public static formatReadableTime(inpDt: Date): string {

		if (inpDt === null) {
			return null;
		}

		let hours = inpDt.getHours();
		let minutes = inpDt.getMinutes();
		const ampm = hours >= 12 ? 'pm' : 'am';

		hours = hours % 12;
		hours = hours ? hours : 12; // the hour '0' should be '12'

		minutes = Number(minutes < 10 ? '0' + minutes : minutes);

		const strTime = hours + ':' + minutes + ' ' + ampm;
		return strTime;

	}
	public static chkDateOfBirth(inpDt: string, ageMin: number = 0): string {

		let retStr = '';

		if (inpDt === 'Invalid Date') {
			return inpDt;
		}

		try {
			const testDate: Date = new Date(inpDt);

			if (testDate.toString() === 'Invalid Date') {
				retStr = 'Error: An Invalid date format was specified';
				return retStr;
			}
			if (testDate > new Date()) {
				retStr = 'Error: Date of birth cannot be in the future';
				return retStr;
			}

			const birthYear = testDate.getFullYear();
			const currYear = new Date().getFullYear();

			if (currYear - birthYear >= 100) {
				retStr = 'Warning: This DOB is over 100 years old!';
				return retStr;
			}

			if (ageMin > 0) {

				const numMonths = (ageMin * 12);
				const currDate = new Date();
				const moPast = Math.max(0, (currDate.getFullYear() - testDate.getFullYear()) * 12 - testDate.getMonth() + currDate.getMonth());

				if (moPast < numMonths) {
					retStr = "Warning: This member is under " + ageMin + " years old";
					return retStr;
				}
			}
		}
		catch (error) {
			retStr = error.toString();
			return retStr;
		}
		return retStr;
	}
	public static returnStringFromDate(inpDate: Date, fmt = "YYYY-MM-DD"): string {

		if (inpDate === null) {
			return '';
		}

		let retStr: string = '';
		if (fmt === 'YYYY-MM-DD') {
			retStr =
				inpDate.getFullYear() + '-' + inpDate.getMonth() + 1 + '-' + inpDate.getDay();
		}
		if (fmt === 'MM-DD-YYYY') {
			retStr =
				inpDate.getMonth() + 1 + '/' + inpDate.getDay() + '/' + inpDate.getFullYear();
		}

		return retStr;

	}
	public static returnTZTime(inpDt: any): string {
		const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
		const isoDateString = (new Date(inpDt - tzoffset)).toISOString().slice(0, -1);

		return isoDateString;
	}
	public static getCurrentDateTimeWithTimeZone(): string {
	    const now = new Date();
	
	    const year = now.getFullYear();
	    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed, so +1
	    const day = String(now.getDate()).padStart(2, '0');
	
	    const hours = String(now.getHours()).padStart(2, '0');
	    const minutes = String(now.getMinutes()).padStart(2, '0');
	    const seconds = String(now.getSeconds()).padStart(2, '0');
	
	    const timezoneOffset = -now.getTimezoneOffset(); // in minutes, so we negate it
	    const offsetSign = timezoneOffset >= 0 ? '+' : '-';
	    const offsetHours = String(Math.floor(Math.abs(timezoneOffset) / 60)).padStart(2, '0');
	    const offsetMinutes = String(Math.abs(timezoneOffset) % 60).padStart(2, '0');
	
	    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}${offsetSign}${offsetHours}:${offsetMinutes}`;
	}
	public static returnCurrentDateTime(justDate: boolean = false): string {


		const isoDateString = DwUtils.returnTZTime(Date.now());

		const datePart = isoDateString.split('T')[0];
		const timePart = isoDateString.split('T')[1].substring(0, 5);

		if (justDate === true) {
			return datePart;
		}

		return datePart + ' ' + timePart;
	}
	public static boolToInt(inp: any): number {

		if (inp === null) {
			return null;
		}

		if ((inp === true) || (inp === 1)) {
			return 1;
		}

		return 0;
	}
	public static getDaysFromDate(inpDt: Date): number {

		let retDays = 0;
		const nowDate = new Date();

		if (inpDt === undefined || inpDt === null) {
			return 0;
		}

		const differenceInTime = nowDate.getTime() - inpDt.getTime();
		retDays = differenceInTime / (1000 * 3600 * 24);

		return retDays;
	}
	public static getDueDate(current: Date, numDays: number): Date {

		if (numDays === 0) {
			return new Date();
		}

		current.setDate(current.getDate() + numDays);

		return current;
	}
	public static formatDTFromDate(inpDt: Date, justDateFlag: boolean = false): string {

		if (inpDt === undefined || inpDt === null) {
			return '';
		}

		const dt1 = DwUtils.returnTZTime(inpDt);    //new Date(inpDt).toISOString();
		const retStr = DwUtils.formatDTFromString(dt1);

		if (justDateFlag === true) {
			return retStr.split(' ')[0];
		}
		else {
			return retStr;
		}
	}
	public static formatDTFromString(inpStr: string): string {
		if (inpStr === undefined || inpStr === '')
			return inpStr;

		let delim = 'T';
		if (!inpStr.includes('T')) {
			delim = ' ';
		}

		const datePart = inpStr.split(delim)[0];
		const timePart = inpStr.split(delim)[1].substring(0, 5);

		return datePart + ' ' + timePart;
	}
	public static formatDTFromISOString(isoString) {
		// Parse the ISO date string into a Date object
		const date = new Date(isoString);

		// Extract the components
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		let hours = date.getHours();
		const minutes = String(date.getMinutes()).padStart(2, '0');
		const seconds = String(date.getSeconds()).padStart(2, '0');

		// Determine AM/PM and convert to 12-hour format
		const ampm = hours >= 12 ? 'PM' : 'AM';
		hours = hours % 12;
		hours = hours ? hours : 12; // the hour '0' should be '12'
		const hoursStr = String(hours).padStart(2, '0');

		// Format the components into the desired string format
		const formattedDate = `${year}-${month}-${day} ${hoursStr}:${minutes}:${seconds} ${ampm}`;

		return formattedDate;
	}
	
	public static formatDTFromISOStringWhithoutSeconds(isoString: string): string {
    // Parse the ISO date string into a Date object
    const date = new Date(isoString);

    // Extract the components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // Determine AM/PM and convert to 12-hour format
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const hoursStr = String(hours).padStart(2, '0');

    // Format the components into the desired string format (YYYY-MM-DD HH:MM AM/PM)
    const formattedDate = `${year}-${month}-${day} ${hoursStr}:${minutes} ${ampm}`;

    return formattedDate;
}

	public static formatDateToYYMMDD(inpStr: string): string {
		if (inpStr === undefined || inpStr === '')
			return inpStr;

		const delim = ',';
		let first = inpStr.split(delim)[0];
		const delim2 = '/';

		let retstr = first.split(delim2)[2] + '-' + first.split(delim2)[0] + '-' + first.split(delim2)[1];

		return retstr;
	}
	public static formatDateFromString(inpStr: string): string {
		if (inpStr === undefined || inpStr === '' || inpStr === null) {
			return inpStr;
		}

		let delim = 'T';
		if (!inpStr.includes('T')) {
			delim = ' ';
		}
		const datePart = inpStr.split(delim)[0];
		return datePart;
	}
	public static formatDecimal = (value, decimal) => {
		return parseFloat(parseFloat(value).toFixed(decimal)).toLocaleString(
			'en-IN',
			{
				useGrouping: true,
			}
		);
	}

	public static capitalize(inp: string): string {
		if (inp === null) {
			return ''
		}
		return inp.replace(/^\w|\s\w/g, t => t.toUpperCase());
	}

	public static downshift(inp: string): string {
		if (inp === null) {
			return '';
		}
		return inp.toLowerCase();
	}

	public static setFocus(element: string) {

		if (element === null) {
			return;
		}

		setTimeout(() => {
			//console.log('element: ' + element.toString());
			try {
				document.getElementById(element).focus();
			} catch { }
		}, 300);

	}
	public static highlightFocus(element: string) {

		if (element === null) {
			return;
		}

		setTimeout(() => {
			const val = document.getElementById(element) as HTMLInputElement;
			val.focus();
			val.select();
		}, 300);
	}
	public static formClickableEmailAddress(inpAddress: string): string {

		let retVal = '';

		if (inpAddress.length === 0) {
			return retVal;
		}

		retVal = '<a href="mailTo:' + inpAddress + '">' + inpAddress + '</a>';
		return retVal;
	}

	public static returnDecimalFromString(inp: string): number {

		if (inp === undefined) {
			return 0;
		}
		const retVal = inp.replace('$', '');
		const newRetVal = retVal.replace('\,', '');

		return Number(newRetVal);
	}
	public static returnZeroForNull(inp: string): number {
		if (inp === undefined) {
			return 0;
		}
		return Number(inp);
	}
	public static returnBlankForNull(inp: any): string {
		if (inp === null) {
			return '';
		}

		return inp;
	}
	public static checkWWWAddress(inpAddress): string {
		let retVal = '';

		if (inpAddress.length === 0) {
			return retVal;
		}

		if (inpAddress.substring(1, 4) === 'http') {
			return inpAddress;
		}
		else if (inpAddress.substring(1, 3) === 'www') {
			retVal = 'https://' + inpAddress;
		}
		else {
			retVal = 'https://www.' + inpAddress;
		}
		return retVal;

	}
	public static stringToDate(inpStr: string): Date {

		if (inpStr.length === 0) {
			return new Date();
		}

		const parts = inpStr.split('-');
		const retDate = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));

		return retDate;

	}
	public static returnAmountString(amount: number, uom: string): string {

		if (amount === null) { return ' - '; }

		if (uom === undefined) {
			return DwUtils.formatNumber(amount) + ' unk';
		}

		return DwUtils.formatNumber(amount) + ' ' + uom;

	}
	public static formatNumber(num): string {
		return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
	}
	public static evaluateCoalesce(inpVal: string, replaceVal: string): string {
		if (inpVal.length === 0)
			return replaceVal;

		return inpVal;
	}
	public static decimalFmtValue(inp: string): string {
		return parseFloat(inp).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}
	public static checkMultipleEmailAddresses(addresses: any): boolean {

		if (addresses === undefined) {
			return false;
		}
		/** blanks allowed **/
		if (addresses.length === 0) {
			return true;
		}

		const arr = addresses.split(';');
		for (const rec of arr) {

			if (this.validEmailAddress(rec.trim()) !== true) {
				return false;
			}
		}

		return true;
	}

	public static validEmailAddress(inp: string): boolean {

		if (inp === undefined) {
			return false;
		}

		if (inp.length === 0) {
			return false;
		}
		let validated: boolean;
		const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

		validated = regexp.test(inp);
		return validated;
	}
	public static validUserName(inp: string): boolean {
		if (inp === undefined) {
			return false;
		}

		if (inp.length === 0) {
			return false;
		}
		let validated: boolean;
		const regexp = new RegExp(/^(\d|\w)+$/);

		validated = regexp.test(inp);
		return validated;
	}
	public static meetsPasswordRequirements(inp: String): string {

		let upperCaseCheck: boolean = false;
		let lowerCaseCheck: boolean = false;
		let numberCheck: boolean = false;
		let symbolCheck: boolean = false;

		if (inp.length < 12) {
			return "Error: Password must be at least 12 characters";
		}
		let i = 0;

		while (i <= inp.length) {
			let character: any = inp.charAt(i);

			if ((character >= '0' && character <= '9')) {
				numberCheck = true;
			}
			else {
				if (character === character.toUpperCase()) {
					upperCaseCheck = true;
				}
				if (character === character.toLowerCase()) {
					lowerCaseCheck = true;
				}

				if (DwUtils.isSymbol(character) === true) {
					symbolCheck = true;
				}
			}
			i++;
		}

		if (upperCaseCheck === false) {
			return 'Error: Password must contain an upper case character';
		}
		if (lowerCaseCheck === false) {
			return 'Error: Password must contain a lower case character';
		}
		if (numberCheck === false) {
			return 'Error: Password must contain at least one number';
		}
		if (symbolCheck === false) {
			return 'Error: Password must contain at least one symbol';
		}

		return "OK";
	}
	public static isSymbol(inp: string): boolean {

		const format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

		if (format.test(inp)) {
			return true;
		} else {
			return false;
		}
	}
	public static getStatusColor(requestStatusId: number): string {
		switch (requestStatusId) {
			case 1:
				return 'black'; // Unmatched
			case 2:
				return 'blue'; // Matched
			case 3:
				return 'green'; // Approved
			case 4:
				return 'red'; // Denied
			case 5:
				return 'orange'; // Cancelled
			default:
				return ''; // Handle any other status or return a default color
		}
	}
	public static genAlphaNumericKey(): string {
		return Math.random().toString(36).split('').filter(function(value, index, self) {
			return self.indexOf(value) === index;
		}).join('').substring(2, 9).toUpperCase();
	}
	public static stringToBool(inpStr: any): boolean {
		if (inpStr === undefined) {
			return null;
		}
		if (inpStr.toLowerCase() === 'true') {
			return true;
		}

		return false;

	}
	public static getLocalTimezoneOffset(): string {
		const offset = new Date().getTimezoneOffset();
		let offsetHours = Math.floor(Math.abs(offset / 60));
		let offsetMins = Math.abs(offset % 60);
		let formattedOffset = 'Z';

		let offSetHoursStr = String(offsetHours);
		let offsetMinsStr = String(offsetMins);

		if (offsetHours < 10)
			offSetHoursStr = '0' + offsetHours;
		if (offsetMins < 10)
			offsetMinsStr = '0' + offsetMins;

		if (offset < 0) {
			formattedOffset = '+' + offSetHoursStr + ':' + offsetMinsStr;
		} else if (offset > 0) {
			formattedOffset = '-' + offSetHoursStr + ':' + offsetMinsStr;
		} else if (offset === 0) {
			formattedOffset = 'Z';
		}
		return formattedOffset;
	}
	public static returnFullName(first: string, middle: string, last: string): string {
		if ((first === undefined) || (last === undefined)) {
			return '';
		}

		if ((middle === undefined) || (middle === null)) {
			return first + ' ' + last;
		}

		return first + ' ' + middle + ' ' + last;

	}
	public static createDuplicateKey(first: string = null, last: string = null, dob: string = null, gender: string = null): string {

		let duplicateKey = '';
		const safeFirst = (first || '').trim();
		const safeLast = (last || '').trim();
		const safeDobRaw = (dob || '').trim();
		const safeGender = (gender || '').trim();

		/** must have three parameters **/
		if (!safeFirst || !safeLast || !safeDobRaw) {
			return duplicateKey;
		}

		const dobMatch = safeDobRaw.match(/^(\d{4}-\d{2}-\d{2})/);
		if (!dobMatch) {
			return duplicateKey;
		}
		const dobPart = dobMatch[1].replace(/-/g, '');

		duplicateKey = safeFirst.substr(0, 1) + safeLast + dobPart;

		if ((safeGender !== '') && (safeGender !== 'Unknown')) {
			duplicateKey += safeGender.substr(0, 1);
		}

		return duplicateKey;
	}

	public static calculateDaysLeft(dueDate: Date, dateCreated: Date,) {
		let daysLeft = 0;
		if (dueDate) {
			const currentDate = new Date(); // Get the current date
			const createdDate = dateCreated || currentDate; // Use currentDate if dateCreated is not available

			// Calculate daysLeft (positive or zero)
			const timeDifference = dueDate.getTime() - currentDate.getTime();
			daysLeft = Math.max(0, Math.ceil(timeDifference / (1000 * 3600 * 24)));
		}
		return daysLeft;
	}
	public static calculateDaysLapsed(dueDate: Date, dateCreated: Date,) {
		let daysLapsed = 0;
		if (dueDate) {
			const currentDate = new Date(); // Get the current date
			const createdDate: Date = dateCreated || currentDate; // Use currentDate if dateCreated is not available

			// Calculate daysLapsed (positive value)
			const lapsedTimeDifference = currentDate.getTime() - createdDate.getTime();
			daysLapsed = Math.max(0, Math.floor(lapsedTimeDifference / (1000 * 3600 * 24)));

		}
		return daysLapsed;
	}

}
